


























import { Installer } from '@/types';
import Vue from 'vue';

export default Vue.extend({
  computed: {
    installers(): Installer[] {
      return this.$store.state.profile.installers.filter(
        ({ name }: Installer) => name != 'Wocozon',
      );
    },
  },
});
